module.exports = __webpack_public_path__ + "img/logo.e6029bb7.svg";